
// This is an auto generated file - do not edit!
// Swagger path: /api/Activity/{id}/attachment

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    FileIndex, ActivityFile
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class ActivityIdAttachmentApiService extends BaseApiService {
    
    get(id: string, options = {}): Observable<FileIndex[]> {
        return this._get<FileIndex[]>(
            `/Activity/${id}/attachment`,
            options
        );
    }

    post(id: string, activityFile: any, options = {}): Observable<ActivityFile[]> {
        return this._post<ActivityFile[], any>(
            `/Activity/${id}/attachment`,
            activityFile,
            options
        );
    }
}
